// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueMaterial from 'vue-material'
import BootstrapVue from 'bootstrap-vue'
import Toasted from 'vue-toasted'
import VueAnimateNumber from 'vue-animate-number'
import VueObserveVisibility from 'vue-observe-visibility'
import 'vue-material/dist/vue-material.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueMaterial)
Vue.use(BootstrapVue)
Vue.use(Toasted)
Vue.use(VueAnimateNumber)
Vue.use(VueObserveVisibility)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6WgsrW4qoG-VsD5txgHyt588m7CuFA9U', // only mock
    libraries: 'places'
  }
})

Vue.config.productionTip = false

let app
/* eslint-disable no-new */
if (!app) {
  /* eslint-disable no-new */
  app = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
  })
}



// WEBPACK FOOTER //
// ./src/main.js